<sirius-container>
    @if (backgroundImage) {
        <sirius-image-item
            class="banner-background"
            [image]="backgroundImage"
            [imageData]="imageData"
            objectFit="cover"
            alt=""
            aria-hidden="true" />
    }
    <div class="sir-banner-content">
        <sirius-heading [h]="3" [text]="title" textStyleSize="l"></sirius-heading>
        <sirius-text-html [html]="textHtml" textStyle="paragraph" textStyleSize="l"></sirius-text-html>
    </div>
    @if (button) {
        <div class="sir-banner-actions">
            <a
                siriusButton
                [siriusLink]="button.link"
                [iconName]="button.iconName"
                [buttonText]="button.link.title"
                [buttonType]="buttonType"></a>
        </div>
    }
</sirius-container>
